import axiosInstance from '../../../axios-config';

const verifyAuthRepUrl = '/api/authRep/signup/verifyInvitationToken';

export const verifyAuthRep = (pin, token) =>
  axiosInstance.get(verifyAuthRepUrl + `/${pin}/${token}`);
